import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router'
import Loading from './ReusableFunctions/Loader';
import { login, logoutUser } from './apis/authentication';
import Popup from './ReusableFunctions/Popup';
import { setUser } from './reducers/userReducer';
import { ROUTES } from './routes';

export default function Authentication() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()
  const reduxUser = useSelector((state) => state.user.user);
  useEffect(() => {
    initData();
  }, [navigate]);

  const checkSubscriptionActive = (subscription) => {
    if (!subscription) return false; // No subscription
    const isTrial = subscription?.type === 'trial' || subscription?.type === 'lifetime';
      if (!isTrial && subscription.razorpay_status !== 'active') return false; 
    if (subscription.start_date && subscription.end_date) {
      const now = new Date();
      const start = new Date(subscription.start_date);
      const end = new Date(subscription.end_date);
      return now < end;
    }
    return false;
  };


  const redirectToSubscriptionPage=()=>{
   navigate(ROUTES.SUBSCRIPTION_PLANS)
  }

  const initData = async () => {
    try {
      let user = await login();
      if (!user) {
        navigate('/login');
      } else {
        dispatch(setUser(user));
      }

      if (reduxUser && !reduxUser.dsp?.is_verified && !reduxUser?.is_pdrl_admin) {
        navigate('/onboarding/form');
      }

      if (user && user.dsp.is_verified && !user.is_pdrl_admin && location.pathname !== '/plan-purchase') {
        if (!user.subscription) {
          Popup.alert(
            "No Subscription",
            "You do not have an active subscription plan. Please subscribe to continue using the app or contact 8550978888",
            "ERROR",
            redirectToSubscriptionPage,
            null,
            "Buy Now",
            redirectToSubscriptionPage
          );
          return;
        }
        if (!checkSubscriptionActive(user.subscription)) {
          Popup.alert(
            "Subscription Expired",
            "Your subscription has expired. Reach out to +91 8550978888 to continue.",
            "ERROR",
            redirectToSubscriptionPage,
            null,
            "Renew Plan",
            redirectToSubscriptionPage,
          );
          return;
        }
      }

    } catch (err) {
      console.log("err", err);
      Loading.set(false);
    }
  }
  return (
    <div></div>
  )
}
